export const GIVE_OUT = 'benefitGiveOutPage/GIVE_OUT';
